import authService from './authService';

export class DataService {

    readonly url: string

    constructor(url: string) {
        this.url = url
    }

    private prepararFetch(method: string, opciones: any = {}){

        let url = this.url

        if (opciones.subruta) {
            url += "/" + opciones.subruta
        }

        if (opciones.getParams) {
            // const encoder = new UrlEncorder()
            // url += "?" + encoder.encode(opciones.getParams)

            delete opciones.getParams
        }

        const token = authService.getToken()

        return fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${token}`
            },
            ...opciones
        })
    }

    private async makeRequest(method: string, opciones: any = {}) {

        const response = await this.prepararFetch(method, opciones)

        let contenido

        try {
            contenido = await response.json()
        }
        catch {
            contenido = response.body
        }

        if (response.ok) {    
            return contenido
        }
        // Hay que tirar el error manualmente, fetch solo tira el error cuando el servidor no esta disponible
        throw contenido
    }

    get(getParams: any = {}, subruta = ""): Promise<any[]> {
        return this.makeRequest("GET", { getParams, subruta })
    }

    post(data = {}, stringify = true, subruta = "") {
        const opciones = {
            body: stringify ? JSON.stringify(data) : data, // body data type must match "Content-Type" header
            subruta
        }
        return this.makeRequest("POST", opciones)
    }

    delete(subruta = ""){
        return this.makeRequest("DELETE", { subruta })
    }

    private guardar(data: any = {}, stringify = true) {

        //Se hace temporalmente para que sea compatible con el controlador del api
        if(data?.id === null){
            console.warn("id es null en", { data })
            data.id = 0
        }
                
        const opciones = {
            body: stringify ? JSON.stringify(data) : data // body data type must match "Content-Type" header
        }

        const method = data.id ? "PUT" : "POST";

        return this.makeRequest(method, opciones)
    }
}